import { render } from "./SuccessBox.vue?vue&type=template&id=2fc4c394&scoped=true&ts=true"
import script from "./SuccessBox.vue?vue&type=script&lang=ts"
export * from "./SuccessBox.vue?vue&type=script&lang=ts"

import "./SuccessBox.vue?vue&type=style&index=0&id=2fc4c394&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc4c394"]])

export default __exports__